const setAxiosDefaultHeaders = (axiosInstance) => {
  // eslint-disable-next-line no-param-reassign
  axiosInstance.defaults.headers.common = {
    ...axiosInstance.defaults.headers.common,
    'X-Requested-With': 'XMLHttpRequest',
  };
};

export default setAxiosDefaultHeaders;
